import Footer from "components/footer/FooterAuthDefault";
import authImg from "assets/img/auth/auth.png";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import { renderLayoutRoutes } from "routeHelpers";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

export default function Auth() {
  return (
    <div className="min-h-screen bg-white dark:bg-navy-900">
      <FixedPlugin />
      <main className="relative flex min-h-screen items-center justify-center px-4">
        <div className="w-full max-w-md">
          <Routes>
            {renderLayoutRoutes("/auth")}
            <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
          </Routes>
        </div>
        <Footer />
      </main>
    </div>
  );
}
